import React from 'react';
import DialogBase from './DialogBase';
import { Icon } from '@mui/material';

interface DialogDeleteProps {
  open: boolean;
  name?: string;
  onClose: () => void;
  onDelete: () => void;
}

const DialogDelete: React.FC<DialogDeleteProps> = ({
  open,
  name,
  onClose,
  onDelete
}) => {

  return (
    <DialogBase
      open={open}
      title="Verwijderen"
      contentText={ `Weet je zeker dat je ${name ? name : 'dit item'} wilt verwijderen?` }
      confirmButtonText="Verwijderen"
      confirmButtonIcon={<Icon>delete</Icon>}
      onClose={onClose}
      onConfirm={onDelete}
    >
    </DialogBase>
  );
};

export default DialogDelete;
